export class PartNumberRelated {

    public id: number;
    public name: string;
    public description: string;
    public valueStream: string;
    public sapGroup: string;
    public sapFamily: string;

    constructor(partnumberRelated: any = {}) {
        this.id = partnumberRelated.id || 0;
        this.name = partnumberRelated.name || '';
        this.description = partnumberRelated.description || '';
        this.valueStream = partnumberRelated.valueStream || '';
        this.sapGroup = partnumberRelated.sapGroup || '';
        this.sapFamily = partnumberRelated.sapFamily || '';
    }

    get nameWithSAP() {
        return `${this.name} ( ${this.sapGroup} - ${this.sapFamily} )`
    }
}

